<ng-container *ngIf="seconds">
 <span *ngIf="seconds > 3600 * 24" class="text-danger" [ngClass]="ngClass">
   {{seconds / (3600 * 24) | toFixed:0:'down'}} days
 </span>
  <span *ngIf="seconds > (3600) && seconds < (3600 * 24)" class="text-primary" [ngClass]="ngClass">
   {{seconds / 3600 | toFixed:0:'down'}} hours,
    {{seconds % 3600 / 60 | toFixed:0:'down'}} mins
 </span>
  <span *ngIf="seconds <= 3600" class="text-primary" [ngClass]="ngClass">
    <span *ngIf="seconds / 60 >= 1">{{seconds / 60 | toFixed:0:'down'}} mins</span><span
      *ngIf="seconds % 60 < 59"><span *ngIf="seconds / 60 >= 1">,</span>
    {{seconds % 60 | toFixed:0:'up'}} seconds</span>
 </span>
</ng-container>
